import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { TechnicalDisclaimer } from "../components/site/TechnicalDisclaimer";
import { CTASection } from "../components/site/CTASection";
import { CALCULATORS } from "../data/technical";

export default function CalculatorsList() {
  return (
    <div>
      <PageHero
        variant="dark"
        label="Engineering Calculators"
        title="Polyurethane Calculators"
        intro="Practical calculation tools for engineers, formulators, technical sales professionals and industrial users. Each calculator combines a live tool with explanation, worked examples and common mistakes."
        crumbs={[{ label: "Technical Hub", to: "/technical-hub" }, { label: "Calculators" }]}
      />

      <section className="border-b border-brand-line bg-white">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
          <div className="grid gap-px border border-brand-line bg-brand-line md:grid-cols-2">
            {CALCULATORS.map((c, i) => (
              <Link
                key={c.slug}
                to={`/technical-hub/calculators/${c.slug}`}
                data-testid={`calc-list-${c.slug}`}
                className="group flex flex-col bg-white p-8 transition-colors hover:bg-brand-blue/[0.03]"
              >
                <div className="font-mono text-sm font-semibold text-brand-red">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <h2 className="mt-3 font-heading text-xl font-bold text-brand-ink group-hover:text-brand-blue">
                  {c.title}
                </h2>
                <p className="mt-2 flex-1 text-[15px] leading-relaxed text-brand-muted">{c.short}</p>
                <code className="mt-4 block bg-brand-bg px-3 py-2 font-mono text-xs text-brand-ink/70">
                  {c.formula}
                </code>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-blue">
                  Open calculator <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            ))}
          </div>
          <div className="mt-10">
            <TechnicalDisclaimer />
          </div>
        </div>
      </section>

      <CTASection primary={{ to: "/technical-hub/polyurethane", label: "PU Knowledge Centre" }} secondary={{ to: "/advisory/industrial-advisory", label: "Industrial Advisory" }} />
    </div>
  );
}
